import '@vanilla-extract/css/vanilla.virtual.css?ve-css=QGtleWZyYW1lcyBfMTFwYzRiYjAgewogIDAlIHsKICAgIHRyYW5zZm9ybTogcm90YXRlKDApOwogIH0KICAxMDAlIHsKICAgIHRyYW5zZm9ybTogcm90YXRlKDM2MGRlZyk7CiAgfQp9';
import '@vanilla-extract/css/vanilla.virtual.css?ve-css=Ll8xMXBjNGJiNCB7CiAgZmxleDogbm9uZTsKICB3aWR0aDogdmFyKC0tXzExcGM0YmIxKTsKICBoZWlnaHQ6IHZhcigtLV8xMXBjNGJiMik7CiAgYW5pbWF0aW9uOiB2YXIoLS1fMTFwYzRiYjMpOwp9';
import '@vanilla-extract/css/vanilla.virtual.css?ve-css=Ll8xMXBjNGJiNSB7CiAgd2lkdGg6IDEwMCU7CiAgaGVpZ2h0OiAxMDAlOwp9';
export var rotateKeyframes = '_11pc4bb0';
export var widthVar = 'var(--_11pc4bb1)';
export var heightVar = 'var(--_11pc4bb2)';
export var animationVar = 'var(--_11pc4bb3)';
export var wrapper = '_11pc4bb4';
export var icon = '_11pc4bb5';